import React, { useEffect } from "react";
import { useApi } from "../../auth";
import { Savings } from "../../components/organisms/sections/savings/savings";
import "./dashboard.css";
import { Economy } from "../../components/organisms/sections/economy";
import { Water } from "../../components/organisms/sections/water";
import { CarbonDioxide } from "../../components/organisms/sections/carbon-dioxide";
import { Microplastics } from "../../components/organisms/sections/microplastics";
import { ShareSavings } from "../../components/organisms/sections/share-savings";
import { SavingsOverTime } from "../../components/organisms/sections/savings-over-time";
import { Contact } from "../../components/organisms/sections/contact";
import { Helmet } from "react-helmet";

export const Dashboard: React.FunctionComponent = () => {
  const { api } = useApi();

  useEffect(() => {
    api.getAuthenticatedData();
  }, [api]);

  return (
    <div className="Dashboard">
      <Helmet>
        <meta name="viewport" content="width=1440, initial-scale=0" />
      </Helmet>
      <Savings />
      <Economy />
      <Water />
      <CarbonDioxide />
      <Microplastics />
      <ShareSavings />
      <SavingsOverTime />
      <Contact />
    </div>
  );
};
